import {TableColumnWidthUnit} from './table-column-width-unit';

export class Pr implements TableColumnWidthUnit {

    public static readonly unitNumberSuffix = '%';

    public static mapToPx(widths: Pr[], totalPx: number): number[] {
        const sumPercent: number = widths
            .reduce((sum, width) => sum + width.value, 0);

        return widths.map(width => width.toPx(totalPx, sumPercent));
    }

    constructor(
        public value: number
    ) {}

    public toPx(totalPx: number, sumPercent?: number): number {
        const fraction: number = sumPercent ? this.value / sumPercent : this.value / 100;
        const px = Math.floor(fraction * totalPx);

        return Math.min(px, totalPx);
    }

    public adjustToPx(oldValuePx: number, newValuePx: number): void {
        // Zero/NaN old value (e.g. transient measurement of a hidden table)
        // would turn the ratio into NaN/Infinity and persist it in the config.
        if (!(oldValuePx > 0) || !(newValuePx > 0)) {
            return;
        }

        this.value = this.value * newValuePx / oldValuePx;
    }

    public toString(): string {
        return `${this.value}${Pr.unitNumberSuffix}`;
    }

}
